import { c as _c } from "react/compiler-runtime";
import { PersonData } from "@/sanity/interfaces";
import BaseLink from "../common/base-link/base-link";
import css from "../resources/resource/resource-breadcrumbs/resource-breadcrumbs.module.scss";
import { ResourceHubPage } from "@/sanity/sanity.types";
interface IResourceBreadcrumbsProps {
  data: PersonData;
  landingPageData: ResourceHubPage;
}
const ArticleBreadCrumb = props => {
  const $ = _c(4);
  const {
    data,
    landingPageData
  } = props;
  if (!data._id || !data.name) {
    return null;
  }
  const t0 = landingPageData.label ?? "Resource Center";
  let t1;
  if ($[0] !== t0) {
    t1 = [{
      label: t0,
      href: "/learn"
    }];
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const breadcrumbs = t1;
  let t2;
  if ($[2] !== breadcrumbs) {
    t2 = <nav className={css.breadcrumbs}><ul className={css.breadcrumbsList}>{breadcrumbs.map(_temp)}</ul></nav>;
    $[2] = breadcrumbs;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default ArticleBreadCrumb;
function _temp(item, index) {
  return <li key={index} className={css.breadcrumbsListItem}>{index > 0 && <span className={css.breadcrumbsSeparator}>/</span>}<BaseLink className={css.breadcrumbsListItemLink} href={item.href}>{item.label}</BaseLink></li>;
}